import React, { useState } from 'react';
import '../../../entrydoor.css';


const RetractableScreen = ({ value, onChange, label = 'Retractable Screen:', disabled = false }) => {
    const [selectedRetractableScreen, setSelectedRetractableScreen] = useState(value || "No");

    const handleRetractableScreenChange = (e) => {
        const value = e.target.value;
        setSelectedRetractableScreen(value);

        handleRetractableScreenChange2(value);
        onChange(e.target.value);
      };
  
    function handleRetractableScreenChange2(value) {
        //const value = e.target.value;
        const ScreenFrameMatchSelect = document.getElementById("ScreenFrameMatch");
        const ScreenFrameMatchLabel = ScreenFrameMatchSelect ? ScreenFrameMatchSelect.previousElementSibling : null;
  
        if (value === "Yes") {
          if (ScreenFrameMatchLabel) ScreenFrameMatchLabel.style.display = "block";
          if (ScreenFrameMatchSelect) ScreenFrameMatchSelect.style.display = "block";
       } else{
          if (ScreenFrameMatchLabel) ScreenFrameMatchLabel.style.display = "none";
          if (ScreenFrameMatchSelect) ScreenFrameMatchSelect.style.display = "none";
       }
  
      }  
  
    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="RetractableScreen">{label}</label>
            <select
                disabled={disabled}
                id="RetractableScreen"
                value={selectedRetractableScreen}
                onChange={handleRetractableScreenChange}
            >
                <option value="Yes">{selectedRetractableScreen === "Yes" ? "Yes ✔" : "Yes"}</option>
                <option value="No">{selectedRetractableScreen === "No" ? "No ✔" : "No"}</option>

            </select>
        </div>
    );
};

export default RetractableScreen;

